import { createRoute } from '@tanstack/react-router';
import { IconReceipt2 } from '@tabler/icons-react';
import type { EzyModule } from '../module';
import { readFinanceAccess } from './access';
import { CostDetail } from './CostDetail';
import { CostRoute } from './CostRoute';
import { OpsCost } from './OpsCost';
import { ServiceGP } from './ServiceGP';
import { Settle } from './Settle';
import { SupplierPay } from './SupplierPay';
import {
  ADVANCES, AR_CUSTOMERS, COST_LINES, DEBIT_QUEUE, ISSUED_INVOICES, PENDING_DEBITS, RECEIPTS, SUPPLIER_DOCS, SUPPLIER_INVOICES,
  SUPPLIER_PARTNERS, SUPPLIER_PAYMENTS, TO_INVOICE, VOUCHERS,
} from './fixtures';

/** Vùng Tài chính (luồng K): mọi màn sau quyền `money` — menu chỉ hiện cho người có quyền (TODO(A): quyền thật từ phiên đăng nhập). */
const finance: EzyModule = {
  nav: typeof location !== 'undefined' && readFinanceAccess(location.search).money
    ? { key: 'finance', label: 'Tài chính', icon: IconReceipt2, section: 'TÀI CHÍNH', items: [{ key: 'cost', label: 'Chi phí', to: '/ezy/cost' }, { key: 'settle', label: 'Quyết toán tạm ứng', to: '/ezy/settle' }, { key: 'pay', label: 'Phải trả', to: '/ezy/pay' }, { key: 'service-gp', label: 'GP theo dịch vụ', to: '/ezy/service-gp' }, { key: 'opscost', label: 'Chi phí theo mảng', to: '/ezy/opscost' }] }
    : undefined,
  routes: (parent) => [
    createRoute({ getParentRoute: () => parent, path: '/cost', component: CostRoute }),
    createRoute({ getParentRoute: () => parent, path: '/cost/$job', component: CostDetail }),
    createRoute({ getParentRoute: () => parent, path: '/opscost', component: OpsCost }),
    createRoute({ getParentRoute: () => parent, path: '/settle', component: Settle }),
    createRoute({ getParentRoute: () => parent, path: '/pay', component: SupplierPay }),
    createRoute({ getParentRoute: () => parent, path: '/service-gp', component: ServiceGP }),
  ],
  fixtures: (register) => {
    register('finSupplierInvoice', SUPPLIER_INVOICES);
    register('finVoucher', VOUCHERS);
    register('finCostLine', COST_LINES);
    register('finAdvance', ADVANCES);
    register('finSupplierPartner', SUPPLIER_PARTNERS);
    register('finSupplierDoc', SUPPLIER_DOCS);
    register('finSupplierPayment', SUPPLIER_PAYMENTS);
    register('finArCustomer', AR_CUSTOMERS);
    register('finReceipt', RECEIPTS);
    register('finPendingDebit', PENDING_DEBITS);
    register('finToInvoice', TO_INVOICE);
    register('finIssuedInvoice', ISSUED_INVOICES);
    register('finDebitQueue', DEBIT_QUEUE);
  },
};
export default finance;
